import { useTranslation } from 'react-i18next';

export const VatNumberSkeleton = () => {
  const { t } = useTranslation();
  return (
    <div data-testid='dynamic-input-field'>
      <div className='flex gap-2'>
        <div className='w-[121px]'>
          <div className='flex flex-row items-center mb-2'>
            <label className='text-primary text-body-xs' htmlFor='country-vat-number'>
              {t('companySettings:countryCodeLabel')}
            </label>
          </div>
          <div className='w-full h-12 bg-tertiary rounded-sm animate-pulse' />
        </div>
        <div className='w-full'>
          <div className='flex flex-row items-center mb-2'>
            <label className='text-primary text-body-xs' htmlFor='vat-number'>
              {t('companySettings:vatNumberLabel')}
            </label>
          </div>
          <div className='w-full h-12 bg-tertiary rounded-sm animate-pulse' />
        </div>
      </div>
    </div>
  );
};
